import { Injectable } from '@angular/core';
import { orderBy } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class MathUtilityService {
  public median(values: any) {
    if (values.length === 1) {
      return values[0];
    }

    values = orderBy(values);

    return values[Math.round(values.length / 2) - 1];
  }
}
